import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import cx from 'classnames';

// UI
import { Typography } from '@components/typography';
import { Button } from '@components/button';
type Props = {
  title: string;
  capacity: number;
  maxCapacity: number;
  onCapacityUpdate: (capacity: number) => void;
};
export const CapacitySelector: React.FC<Props> = t0 => {
  const $ = _c(11);
  const {
    title,
    capacity,
    maxCapacity,
    onCapacityUpdate
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <Typography variant="body2" component="p" className="font-medium text-primary-main">{title}</Typography>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== maxCapacity) {
    t2 = Array.from({
      length: maxCapacity + 1
    }, _temp);
    $[2] = maxCapacity;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== capacity || $[5] !== onCapacityUpdate || $[6] !== t2) {
    t3 = <div className="flex flex-wrap gap-2">{t2.map(number => <Button key={number} isCircle={true} size="sm" variant="outlined" onClick={() => {
        onCapacityUpdate(number);
      }} className={cx("h-9", "w-9", "text-center", "text-sm", "transition-colors", {
        "px-1.5": number === 0,
        "px-[0.85rem]": number !== 0,
        "bg-pool/60 text-primary-main border-primary-main border-[1.5px]": number === capacity,
        "bg-white text-primary-main border-gray-400 hover:bg-pool/30 hover:border-primary-main": number !== capacity
      })}>{number === 0 ? "Any" : number}</Button>)}</div>;
    $[4] = capacity;
    $[5] = onCapacityUpdate;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <div className="space-y-2">{t1}{t3}</div>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
function _temp(_, i) {
  return i;
}